import { isDealerListing } from '@/features/listing/utils/isDealerListing'
import { type Listing } from '@/types/search'

export const getDealerIds = (listings: Listing[]) =>
  listings.reduce<(string | undefined)[]>((acc, listing) => {
    if (!isDealerListing(listing.attributes)) return acc
    const dealerId = listing.posterInfo?.posterId
    return acc.includes(dealerId) ? acc : [...acc, dealerId]
  }, [])
